<template>
    <div class="bg_green center">
	<div class="inner_width flex flex--column flex--center">
		<div class="bg_404_num"></div>
		<h1 class="title_404">אנחנו לא מוצאים את העמוד שחיפשת, <br />והוא גם לא במגירה של הפירות!</h1>
		<div class="bt_green ease"><router-link :to="{name: 'home'}">חזרה לעמוד הבית</router-link> </div>
	</div>
</div>
</template>
<script>
export default {
    
}
</script>